import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import config from './config/config.json';

const container = document.getElementById('rating_widget');
const root = createRoot(container!);

root.render(
   <React.StrictMode>
       <GoogleReCaptchaProvider reCaptchaKey={config.googleCaptcha.RECAPTCHA_SITE_KEY}>
           <App />
       </GoogleReCaptchaProvider>
   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
